import { render, staticRenderFns } from "./new_payroll_header.vue?vue&type=template&id=b52d64b8&scoped=true"
import script from "./new_payroll_header.vue?vue&type=script&lang=js"
export * from "./new_payroll_header.vue?vue&type=script&lang=js"
import style0 from "./new_payroll_header.vue?vue&type=style&index=0&id=b52d64b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52d64b8",
  null
  
)

export default component.exports